// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import { Message } from '@internal/react-components';

/**
 * @private
 */
export const compareMessages = (firstMessage: Message, secondMessage: Message): number => {
  const firstDate = new Date(firstMessage.createdOn).getTime();
  const secondDate = new Date(secondMessage.createdOn).getTime();
  // Workaround to get a stable order of message before we can get sequenceId from chat service.
  // MessageIds are generated by time order the message persist, a good candidate other than time
  const idDelta =
    firstMessage.messageId && secondMessage.messageId
      ? Number.parseInt(firstMessage.messageId) - Number.parseInt(secondMessage.messageId)
      : 0;
  return firstDate - secondDate === 0 ? idDelta : firstDate - secondDate;
};
